import { Flex, Heading } from "@aws-amplify/ui-react";
import { useNavigate } from "react-router-dom";
import AboutMeCard from "./containers/AboutMeCard";
import InsuranceCard from "./containers/InsuranceCard";

const ProfileSummaryPage = () => {
  const navigate = useNavigate();
  return (
    <Flex direction={"column"} padding="32px 32px 32px 32px" backgroundColor="rgba(250,250,250,1)">
      <Heading level="1" children="Personal Information"></Heading>

      <Flex direction={{ base: "column", medium: "row" }}>
        <AboutMeCard onEditClick={() => navigate("/user/profile/about-me/")} />
        <InsuranceCard
          onEditClick={() => navigate("/user/profile/insurance/")}
        />
      </Flex>
    </Flex>
  );
};

export default ProfileSummaryPage;
